import { Modal } from 'antd';
import React, { useState } from 'react';

import ForgotPassword from '../../Auth/ForgotPassword';

interface ModalComponentProps {
  visible: boolean;
  onCancel: () => void;
}

const ForgotPasswordModal: React.FC<ModalComponentProps> = ({
  visible,
  onCancel,
}) => {
  const [confirmLoading, setConfirmLoading] = useState(false);

  const handleOk = () => {
    setConfirmLoading(true);

    setTimeout(() => {
      setConfirmLoading(false);
      onCancel();
    }, 2000);
  };

  return (
    <Modal
      title=''
      open={visible}
      onOk={handleOk}
      confirmLoading={confirmLoading}
      onCancel={onCancel}
      closable={false}
      footer={false}
      width={600}
    >
      <ForgotPassword isModal={true} onCancel={onCancel} visible={visible} />
    </Modal>
  );
};

export default ForgotPasswordModal;
